module.exports = require("next/dist/compiled/ws");